export default {
  UGCP: "UGCP",
  BLOCK: "Block",
  REPORT: "Report",
};
